import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() label: string | number | undefined;
  @Input() badgeClass: string | undefined;
  @Input() badgeColor: BadgeColor = 'red';
}

export type BadgeColor = "red" | "green" | "orange" | "red-green" | "dark-green" | "blue" |undefined;
